<p-inputGroup>
    <p-inputNumber #inputRef [(ngModel)]="grade" [allowEmpty]=true [min]="gradeType == _GradeType.percent ? 0 : 1" [max]="gradeType == _GradeType.percent ? 999 : 6" [maxFractionDigits]="gradeType == _GradeType.percent ? 3 : 0"
        [inputStyle]="{'width': '60px'}" [step]=0 (onFocus)="focus($event)" (ngModelChange)="change()" (keydown)="keyDown($event)">
    </p-inputNumber>  
    @if (isExamGrade) {
        <button type="button" pButton icon="fas fa-pencil-alt" (click)="editGrade($event, _value)"></button>
    }                            
</p-inputGroup>